function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25.68,
    height: 10.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 5.14
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.28,
    width: 25.68,
    height: 22.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.84625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 21.665
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.06,
    width: 25.68,
    height: 28.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 47.1
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 61.14,
    width: 25.68,
    height: 30.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 76.41
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.68,
    width: 25.68,
    height: 35.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 109.635
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 127.59,
    width: 25.68,
    height: 40.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 147.61
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 167.62,
    width: 25.68,
    height: 44.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6685714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 189.745
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 211.88,
    width: 25.68,
    height: 48.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 236.245
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 260.61,
    width: 25.68,
    height: 49.24,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6685714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 285.23
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 309.85,
    width: 25.68,
    height: 50.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 334.89000000000004
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 359.93,
    width: 25.68,
    height: 52.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 386.03000000000003
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 412.14,
    width: 25.68,
    height: 56.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 440.315
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 468.49,
    width: 25.68,
    height: 56.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 496.77
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 525.06,
    width: 25.68,
    height: 57.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 554.005
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 582.94,
    width: 25.68,
    height: 58.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.568
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 612.0050000000001
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 641.07,
    width: 25.68,
    height: 58.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.84,
    y: 670.5350000000001
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.68,
    y: 0,
    width: 34.55,
    height: 44.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.758333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.955,
    y: 22.495
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.23,
    y: 0,
    width: 35.8,
    height: 44.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.159999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 78.13,
    y: 22.495
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.03,
    y: 0,
    width: 37.56,
    height: 44.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7560000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.81,
    y: 22.495
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.59,
    y: 0,
    width: 40.43,
    height: 44.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.738333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 153.805,
    y: 22.495
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.02,
    y: 0,
    width: 41.57,
    height: 44.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.938571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.805,
    y: 22.495
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.59,
    y: 0,
    width: 43.41,
    height: 44.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.340999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.29500000000002,
    y: 22.495
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.99,
    y: 0,
    width: 44.17,
    height: 44.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.52125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.075,
    y: 22.495
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.17,
    y: 0,
    width: 45.23,
    height: 44.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.427142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 325.785,
    y: 22.495
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.39,
    y: 0,
    width: 45.48,
    height: 44.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.62375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 371.13,
    y: 22.495
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.87,
    y: 0,
    width: 45.63,
    height: 44.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.498333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.685,
    y: 22.495
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.51,
    y: 0,
    width: 45.75,
    height: 44.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.62375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.385,
    y: 22.495
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.25,
    y: 0,
    width: 48.72,
    height: 44.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.427142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.61,
    y: 22.495
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.97,
    y: 0,
    width: 53.79,
    height: 44.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.865,
    y: 22.495
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.76,
    y: 0,
    width: 54.18,
    height: 44.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.498333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.85,
    y: 22.495
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.93,
    y: 0,
    width: 58.07,
    height: 44.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.998888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.9649999999999,
    y: 22.495
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.68,
    y: 44.99,
    width: 57.77,
    height: 46.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.688571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.565,
    y: 68.4
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.68,
    y: 91.81,
    width: 57.77,
    height: 47.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.518
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.565,
    y: 115.605
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.68,
    y: 139.4,
    width: 57.77,
    height: 49.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.115833333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.565,
    y: 164.095
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.68,
    y: 188.8,
    width: 57.77,
    height: 49.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.565,
    y: 213.67000000000002
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.68,
    y: 238.54,
    width: 57.77,
    height: 50.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.195714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.565,
    y: 263.72499999999997
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.68,
    y: 288.91,
    width: 57.77,
    height: 52.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.805
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.565,
    y: 315.32500000000005
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.68,
    y: 341.74,
    width: 57.77,
    height: 57.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.565,
    y: 370.265
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.68,
    y: 398.79,
    width: 57.77,
    height: 60.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.628333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.565,
    y: 428.885
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.68,
    y: 458.98,
    width: 57.77,
    height: 72.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.565,
    y: 495.435
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.68,
    y: 531.9,
    width: 57.77,
    height: 83.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.251818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.565,
    y: 573.4649999999999
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.68,
    y: 615.02,
    width: 57.77,
    height: 84.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.565,
    y: 657.51
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.44,
    y: 44.99,
    width: 70.52,
    height: 79.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.753333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.69999999999999,
    y: 84.775
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.96,
    y: 44.99,
    width: 78.49,
    height: 79.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.081666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.205,
    y: 84.775
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.45,
    y: 44.99,
    width: 84.07,
    height: 79.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.367142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.485,
    y: 84.775
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.52,
    y: 44.99,
    width: 85.69,
    height: 79.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.94625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.365,
    y: 84.775
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.21,
    y: 44.99,
    width: 86.54,
    height: 79.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.261666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.47999999999996,
    y: 84.775
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 488.75,
    y: 44.99,
    width: 100.75,
    height: 79.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.94625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.125,
    y: 84.775
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.5,
    y: 44.99,
    width: 110.5,
    height: 79.57,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.94625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 644.75,
    y: 84.775
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.44,
    y: 124.55,
    width: 114.96,
    height: 78.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.159999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.92,
    y: 164.03
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.44,
    y: 203.51,
    width: 114.96,
    height: 88.58,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.763333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.92,
    y: 247.79999999999998
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.44,
    y: 292.09,
    width: 114.96,
    height: 88.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.08375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.92,
    y: 336.42499999999995
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.44,
    y: 380.76,
    width: 114.96,
    height: 127.05,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.92,
    y: 444.28499999999997
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.44,
    y: 507.8,
    width: 114.96,
    height: 192.2,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.991999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.92,
    y: 603.9
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.41,
    y: 124.55,
    width: 141.77,
    height: 160.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.628333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.295,
    y: 204.935
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.18,
    y: 124.55,
    width: 170.36,
    height: 160.77,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.615454545454547
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.36,
    y: 204.935
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.54,
    y: 124.55,
    width: 189.46,
    height: 160.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 40.1925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 605.27,
    y: 204.935
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.41,
    y: 285.32,
    width: 193.58,
    height: 205.99,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 32.263333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.2,
    y: 388.315
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.41,
    y: 491.31,
    width: 193.58,
    height: 208.69,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 24.1975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.2,
    y: 595.655
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.99,
    y: 285.32,
    width: 151.91,
    height: 270.97,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.701428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.945,
    y: 420.805
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.9,
    y: 285.32,
    width: 156.1,
    height: 270.97,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.016666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 621.9499999999999,
    y: 420.805
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.99,
    y: 556.29,
    width: 308.01,
    height: 143.71,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 28.742
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.995,
    y: 628.145
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2000);
export default __webpack_public_path__ + "static/media/2000.8704962bb38f22546584770b8e6ce7eb.svg";
export { ForwardRef as ReactComponent };